import axios from '@/utils/request'

export default {
  // 2020-08-06
  findByTenantId() {
    return axios.get('/mes/phase-templates/find-by-tenant-id')
  },
  // 2020-08-06
  update(id, params) {
    return axios.put('/mes/phase-templates/' + id, params)
  },
  // 2020-08-06
  create(params) {
    return axios.post('/mes/phase-templates', params)
  },
  // 2020-08-06
  delete(id) {
    return axios.delete('/mes/phase-templates/' + id)
  },
  // 2020-08-06
  findItems(id) {
    return axios.get('/mes/phase-templates/' + id + '/items')
  },
  // 2020-08-06
  deleteItem(id, itemId) {
    return axios.delete('/mes/phase-templates/' + id + '/items/' + itemId)
  },
  //2020-08-06 
  updateItem(id, itemId, params) {
    return axios.put('/mes/phase-templates/' + id + '/items/' + itemId, params)
  },
  //2020-08-06
  createItem(id, params) {
    return axios.post('/mes/phase-templates/' + id + '/items', params)
  },
  //2020-08-06
  findById(id) {
    return axios.get('/mes/phase-templates/' + id)
  },
  // 2021-01-11
  swapSequence(id, params) {
    return axios.put('/mes/phase-templates/' + id + '/items/swap-sequence', params)
  },
  //2021-07-25
  copy(id, params) {
    return axios.put('/mes/phase-templates/' + id + '/copy', params)
  },
}

